import {AutoLinkNode, LinkNode} from '@lexical/link';
import {$convertFromMarkdownString} from '@lexical/markdown';
import {ClickableLinkPlugin} from '@lexical/react/LexicalClickableLinkPlugin';
import {LexicalComposer} from '@lexical/react/LexicalComposer';
import {RichTextPlugin} from '@lexical/react/LexicalRichTextPlugin';
import {captureException} from '@sentry/browser';

import {MARKDOWN_TRANSFORMERS} from './config';
import {AutoLinkPlugin} from './plugins/AutoLinkPlugin';
import {LinkPlugin} from './plugins/LinkPlugin';

interface RichContentDisplayProps {
  markdown: string;
  ContentEditableComponent: React.ReactElement;
}

export function RichContentDisplay(props: RichContentDisplayProps) {
  return (
    <LexicalComposer
      initialConfig={{
        namespace: 'rich-content-display',
        editable: false,
        editorState: () => $convertFromMarkdownString(props.markdown, MARKDOWN_TRANSFORMERS),
        onError: (error) => {
          captureException(error);
        },
        nodes: [LinkNode, AutoLinkNode],
      }}
    >
      <RichTextPlugin contentEditable={props.ContentEditableComponent} ErrorBoundary={() => null} />
      <AutoLinkPlugin />
      <ClickableLinkPlugin />
      <LinkPlugin />
    </LexicalComposer>
  );
}
